"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var logger_const_1 = require("../const/logger.const");
var logger_class_1 = require("../logger/logger.class");
function titleCase(value) {
    if (!value || !lodash_1.isString(value)) {
        logger_class_1.logger.message("Incorrect type or value! " + value, logger_const_1.LOG_TYPE.warning);
        return '';
    }
    var camelCased = lodash_1.camelCase(value);
    return lodash_1.startCase(camelCased);
}
exports.titleCase = titleCase;
function sentenceCase(value) {
    if (!value || !lodash_1.isString(value)) {
        logger_class_1.logger.message("Incorrect type or value! " + value, logger_const_1.LOG_TYPE.warning);
        return '';
    }
    var normalized = lodash_1.chain(value)
        .camelCase()
        .startCase()
        .toLower()
        .value();
    return lodash_1.upperFirst(normalized);
}
exports.sentenceCase = sentenceCase;
function pascalCase(value) {
    if (!value || !lodash_1.isString(value)) {
        logger_class_1.logger.message("Incorrect type or value! " + value, logger_const_1.LOG_TYPE.warning);
        return '';
    }
    var camelCased = lodash_1.camelCase(value);
    return lodash_1.upperFirst(camelCased);
}
exports.pascalCase = pascalCase;
